var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 .917L.917 0 5 4.083 9.083 0 10 .917l-5 5-5-5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNLTQuMDEwNDFlLTA4IDAuOTE3NDc0TDAuOTE3NDczIC00LjAxMDQxZS0wOEw1IDQuMDgyNTNMOS4wODI1MyAtNC4wMTA0ZS0wOEwxMCAwLjkxNzQ3NEw1IDUuOTE3NDdMLTQuMDEwNDFlLTA4IDAuOTE3NDc0WiIgLz4KPC9zdmc+";
export { SvgIconCaretDown as ReactComponent };